import { Badge, Icon, Table } from '@vwfs-bronson/bronson-react';
import { Team } from '../../fes';
import { formatInstallationId } from './teamForm';

export function TeamsTable({
  teams,
  selectedTeamId,
  onSelectTeam,
}: {
  teams: Team[];
  selectedTeamId?: string;
  onSelectTeam: (team: Team) => void;
}) {
  if (teams.length === 0) {
    return <p className="app-empty">No teams found.</p>;
  }

  return (
    <div className="app-table-wrap">
      <Table className="app-table" colored>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Name</Table.Th>
            <Table.Th>Description</Table.Th>
            <Table.Th>Status</Table.Th>
            <Table.Th className="app-table-installation-column">Installation ID</Table.Th>
            <Table.Th className="app-table-actions-column">Details</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {teams.map(team => (
            <Table.Tr
              key={team.teamId || team.name}
              aria-selected={team.teamId === selectedTeamId}
              className="app-table-row--interactive"
              onClick={() => onSelectTeam(team)}
              onKeyDown={event => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  onSelectTeam(team);
                }
              }}
              selected={team.teamId === selectedTeamId}
              tabIndex={0}
            >
              <Table.Td>{team.name}</Table.Td>
              <Table.Td>
                <span className="app-table-description" title={team.description}>
                  {team.description || '-'}
                </span>
              </Table.Td>
              <Table.Td>
                <Badge
                  label={team.status || 'Unknown'}
                  modifier={team.status === 'active' || team.status === 'ACTIVE' ? 'success' : undefined}
                />
              </Table.Td>
              <Table.Td className="app-table-installation-column">
                {formatInstallationId(team.installationId)}
              </Table.Td>
              <Table.Td className="app-table-actions-column">
                <span className="app-team-details-cue" title={`View details for ${team.name}`}>
                  View
                  <Icon name="semantic-forward" size="xsmall" />
                </span>
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </div>
  );
}
